export class SupportEntity {}
